export default function breadcrumbs({ variables, }) {
    return {
        MuiBreadcrumbs: {
            styleOverrides: {
                root: {
                    fontSize: variables.type_caption_font_size,
                    color: variables.text_medium,
                },
                separator: {
                    color: variables.text_medium,
                    marginLeft: variables.spacing_02,
                    marginRight: variables.spacing_02,
                },
            },
        },
    };
}
//# sourceMappingURL=breadcrumbs.js.map